const SIMPLE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const GENERIC_RESET_ERROR_MESSAGE = 'Unable to send reset email right now.';
const FIREBASE_CODE_IN_MESSAGE_REGEX = /(auth\/[a-z0-9-]+)/i;
const INVALID_ACCOUNT_EMAIL_MESSAGE = 'Enter a valid email address for your account and try again.';
const TEMPORARY_RESET_SETUP_MESSAGE =
  'Reset link setup is temporarily unavailable. Please try again shortly.';

const RESET_ERROR_MESSAGES_BY_CODE = Object.freeze(
  Object.assign(Object.create(null), {
    'auth/too-many-requests': 'Too many reset attempts. Please wait a bit and try again.',
    'auth/user-not-found': 'No account found for that email address.',
    'auth/network-request-failed':
      'Network issue while sending reset email. Check your connection and retry.',
    'auth/invalid-email': INVALID_ACCOUNT_EMAIL_MESSAGE,
    'auth/missing-email': INVALID_ACCOUNT_EMAIL_MESSAGE,
    'auth/invalid-continue-uri': TEMPORARY_RESET_SETUP_MESSAGE,
    'auth/missing-continue-uri': TEMPORARY_RESET_SETUP_MESSAGE,
    'auth/unauthorized-continue-uri': TEMPORARY_RESET_SETUP_MESSAGE,
    'auth/operation-not-allowed': TEMPORARY_RESET_SETUP_MESSAGE,
  })
);

function extractFirebaseErrorCode(value) {
  if (typeof value !== 'string') return '';
  const normalized = value.trim().toLowerCase();
  if (!normalized) return '';

  const match = normalized.match(FIREBASE_CODE_IN_MESSAGE_REGEX);
  return match ? match[1] : normalized;
}

function normalizeFirebaseErrorCode(error) {
  const explicitCode = extractFirebaseErrorCode(error?.code);
  if (explicitCode) return explicitCode;

  const message =
    typeof error === 'string' ? error : typeof error?.message === 'string' ? error.message : '';
  return extractFirebaseErrorCode(message);
}

export function normalizeAccountEmail(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function isValidAccountEmail(value) {
  const normalized = normalizeAccountEmail(value);
  return SIMPLE_EMAIL_REGEX.test(normalized);
}

export function toAccountResetErrorMessage(error) {
  const rawStringError = typeof error === 'string' ? error.trim() : '';
  const normalizedObjectMessage =
    typeof error?.message === 'string' ? error.message.trim() : '';
  const code = normalizeFirebaseErrorCode(error);

  if (code && RESET_ERROR_MESSAGES_BY_CODE[code]) {
    return RESET_ERROR_MESSAGES_BY_CODE[code];
  }

  if (code.startsWith('auth/')) {
    return GENERIC_RESET_ERROR_MESSAGE;
  }

  if (rawStringError) {
    return rawStringError;
  }

  if (normalizedObjectMessage) {
    return normalizedObjectMessage;
  }

  return GENERIC_RESET_ERROR_MESSAGE;
}
